import React from 'react'
import Header from '../../Components/Header'
import WireCapabilities from '../../Components/wireCapabilities'
import wire2 from "../../imagens/wires/wire.jpg"
import wire1 from "../../imagens/chicoteMgsul/chicoteMgsul3.jpeg"
import wire3 from "../../imagens/chicoteMgsul/chicoteMgsul4.jpeg"
import wire4 from "../../imagens/chicoteMgsul/chicoteMgsul5.jpeg"
import wire5 from "../../imagens/chicoteMgsul/chicoteMgsul6.jpeg"
import wire6 from "../../imagens/chicoteMgsul/chicoteMgsul7.jpeg"
import wire7 from "../../imagens/chicoteMgsul/chicoteMgsul8.jpeg"
import wire8 from "../../imagens/chicoteMgsul/chicoteMgsul9.jpeg"
import wire9 from "../../imagens/chicoteMgsul/chicoteMgsul10.jpeg"
import wire10 from "../../imagens/chicoteMgsul/chicoteMgsul11.jpeg"
import wire11 from "../../imagens/chicoteMgsul/chicoteMgsul12.jpeg"
import wire12 from "../../imagens/chicoteMgsul/chicoteMgsul13.jpeg"
import wire13 from "../../imagens/chicoteMgsul/chicoteMgsul14.jpeg"
import wire14 from "../../imagens/chicoteMgsul/chicoteMgsul15.jpeg"
import wire15 from "../../imagens/chicoteMgsul/chicoteMgsul16.jpeg"
import wire16 from "../../imagens/chicoteMgsul/chicoteMgsul17.jpeg"
import wire17 from "../../imagens/chicoteMgsul/chicoteMgsul18.jpeg"
import wire18 from "../../imagens/chicoteMgsul/chicoteMgsul19.jpeg"
import wire19 from "../../imagens/chicoteMgsul/chicoteMgsul20.jpeg"
import wire20 from "../../imagens/chicoteMgsul/chicoteMgsul21.jpeg"
import wire21 from "../../imagens/chicoteMgsul/chicoteMgsul22.jpeg"
import wire22 from "../../imagens/chicoteMgsul/chicoteMgsul23.jpeg"
import wire23 from "../../imagens/chicoteMgsul/chicoteMgsul24.jpeg"
import wire24 from "../../imagens/chicoteMgsul/chicoteMgsul25.jpeg"
import wire25 from "../../imagens/chicoteMgsul/chicoteMgsul26.jpeg"
import wire26 from "../../imagens/chicoteMgsul/chicoteMgsul27.jpeg"
import wire27 from "../../imagens/chicoteMgsul/chicoteMgsul28.jpeg"


const listaChicotes = [
    {
        img:wire2
    },
    {
        img:wire1
    },
    {
        img:wire3
    },
    {
        img:wire4
    },
    {
        img:wire5
    },
    {
        img:wire6
    },
    {
        img:wire7
    },
    {
        img:wire8
    },
    {
        img:wire9
    },
    {
        img:wire10
    },
    {
        img:wire11
    },
    {
        img:wire12
    },
    {
        img:wire13
    },
    {
        img:wire14
    },
    {
        img:wire15
    },
    {
        img:wire16
    },
    {
        img:wire17
    },
    {
        img:wire18
    },
    {
        img:wire19
    },
    {
        img:wire20
    },
    {
        img:wire21
    },
    {
        img:wire22
    },
    {
        img:wire23
    },
    {
        img:wire24
    },
    {
        img:wire25
    },
    {
        img:wire26
    },
    {
        img:wire27
    },


    
   
]




function WirePage() {
    return (
        <div>
            <Header/>

            <WireCapabilities
                listaChicotes = {listaChicotes}
                />
        </div>
    )
}

export default WirePage